import React from "react";

import logoFooter from "../../assets/img/landing-pulse/logo.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <img src={logoFooter} alt="Logo Montironi" />
      <p>Imágenes a modo ilustrativo</p>
    </footer>
  );
};
